import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NewFooter from '../../../common/NewFooter'; // Assuming you have a footer component
import ConferenceNav from '../../../common/ConferenceNav';
import SEO from '../../../common/SEO';

const ConferenceList = ({ isEmbedded = false }) => {
  const [activeTab, setActiveTab] = useState('attend');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      {!isEmbedded && (
        <SEO
          title="Scientific Research Conferences & Conference Paper Writing Publication"
          description="Attend and organize premier Scientific Research conferences in Bhopal. IEEE paper writing, Conference paper writing publication, SCI & Scopus paper writing help."
          canonicalPath="/conference-list"
          keywords={[
            "Conference paper writing publication",
            "Scientific Research",
            "IEEE paper writing",
            "Paper Writing Bhopal",
            "Scopus paper writing bhopal",
            "SCI paper writing bhopal",
            "Research paper writing and publication"
          ]}
          breadcrumbs={[
            { name: "Home", path: "/" },
            { name: "Conference Hub", path: "/conference-list" }
          ]}
        />
      )}
      {!isEmbedded && <ConferenceNav />}
      <div className={`bg-gradient-to-br from-gray-50 to-blue-50 pb-8 px-4 sm:px-6 lg:px-8 ${isEmbedded ? 'pt-8' : 'min-h-screen pt-28'}`}>
        <div className='max-w-7xl mx-auto'>
          <div className='text-center mb-12'>
            <h1 className='text-4xl font-extrabold text-gray-900 sm:text-5xl'>
              Conference Hub
            </h1>
            <p className='mt-4 text-xl text-gray-600 max-w-3xl mx-auto'>
              Connecting researchers, academics, and industry professionals
              through premier scientific conferences
            </p>
          </div>

          {/* Mobile menu button */}
          <div className='md:hidden flex justify-center mb-6'>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className='flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors'
            >
              <span className='mr-2'>
                {mobileMenuOpen ? 'Close Menu' : 'Open Menu'}
              </span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-5 w-5'
                viewBox='0 0 20 20'
                fill='currentColor'
              >
                {mobileMenuOpen ? (
                  <path
                    fillRule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clipRule='evenodd'
                  />
                ) : (
                  <path
                    fillRule='evenodd'
                    d='M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z'
                    clipRule='evenodd'
                  />
                )}
              </svg>
            </button>
          </div>

          <div className='flex flex-col md:flex-row gap-8'>
            {/* Left Menu Section - visible on desktop, conditionally on mobile */}
            <div
              className={`${mobileMenuOpen ? 'block' : 'hidden'} md:block w-full md:w-1/4 bg-white rounded-xl shadow-md p-6 h-fit`}
            >
              <div className='menu-section'>
                <h3 className='text-lg font-semibold text-blue-800 mb-4 pb-2 border-b border-gray-200'>
                  Conference Resources
                </h3>
                <ul className='space-y-3'>
                  {/* <li>
                  <Link to="/" className="flex items-center py-2 px-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    About Conferences
                  </Link>
                </li> */}
                  <li>
                    <Link
                      to='/plan-scientific-page'
                      className='flex items-center py-2 px-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2 text-blue-500'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path
                          fillRule='evenodd'
                          d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                          clipRule='evenodd'
                        />
                      </svg>
                      Plan a Scientific Conference
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/sponsor'
                      className='flex items-center py-2 px-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2 text-blue-500'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path d='M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z' />
                      </svg>
                      Sponsors & Exhibitors
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/conference-award'
                      className='flex items-center py-2 px-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2 text-blue-500'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path
                          fillRule='evenodd'
                          d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                          clipRule='evenodd'
                        />
                      </svg>
                      Awards & Recognition
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/workshop'
                      className='flex items-center py-2 px-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2 text-blue-500'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path d='M10 12a2 2 0 100-4 2 2 0 000 4z' />
                        <path
                          fillRule='evenodd'
                          d='M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z'
                          clipRule='evenodd'
                        />
                      </svg>
                      Workshops & Courses
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/faq'
                      className='flex items-center py-2 px-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2 text-blue-500'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path
                          fillRule='evenodd'
                          d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z'
                          clipRule='evenodd'
                        />
                      </svg>
                      Conference FAQ
                    </Link>
                  </li>
                </ul>

                {/* <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-100">
                <h3 className="font-semibold text-blue-800 mb-2">Upcoming Conferences</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    </div>
                    <p className="ml-2 text-sm text-gray-700">Global AI Summit - June 15-17, 2023</p>
                  </li>
                  <li className="flex items-start">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    </div>
                    <p className="ml-2 text-sm text-gray-700">BioTech Innovations - July 22-24, 2023</p>
                  </li>
                  <li className="flex items-start">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    </div>
                    <p className="ml-2 text-sm text-gray-700">Sustainable Energy Forum - August 10-12, 2023</p>
                  </li>
                </ul>
              </div> */}
              </div>
            </div>

            {/* Right Content Section */}
            <div className='w-full md:w-3/4'>
              <div className='bg-white rounded-xl shadow-md overflow-hidden'>
                <div className='tabs flex flex-wrap border-b border-gray-200'>
                  <button
                    className={`px-6 py-4 font-medium text-sm sm:text-base transition-colors ${
                      activeTab === 'attend'
                        ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                        : 'text-gray-600 hover:text-blue-500 hover:bg-gray-50'
                    }`}
                    onClick={() => setActiveTab('attend')}
                  >
                    <span className='flex items-center'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path d='M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z' />
                      </svg>
                      Attend a conference
                    </span>
                  </button>
                  <button
                    className={`px-6 py-4 font-medium text-sm sm:text-base transition-colors ${
                      activeTab === 'organize'
                        ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                        : 'text-gray-600 hover:text-blue-500 hover:bg-gray-50'
                    }`}
                    onClick={() => setActiveTab('organize')}
                  >
                    <span className='flex items-center'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path
                          fillRule='evenodd'
                          d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                          clipRule='evenodd'
                        />
                      </svg>
                      Organize a conference
                    </span>
                  </button>
                  <button
                    className={`px-6 py-4 font-medium text-sm sm:text-base transition-colors ${
                      activeTab === 'join'
                        ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                        : 'text-gray-600 hover:text-blue-500 hover:bg-gray-50'
                    }`}
                    onClick={() => setActiveTab('join')}
                  >
                    <span className='flex items-center'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-5 w-5 mr-2'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                      >
                        <path
                          fillRule='evenodd'
                          d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                          clipRule='evenodd'
                        />
                      </svg>
                      Why join our conferences?
                    </span>
                  </button>
                 
                </div>

                <div className='content p-6'>
                  {activeTab === 'attend' && (
                    <div className='attend-content'>
                      <h2 className='text-2xl font-bold text-gray-800 mb-4'>
                        Attend a Conference
                      </h2>
                      <p className='text-gray-600 mb-6'>
                        AEG Consultancy Services Pvt. Ltd. offers opportunities
                        to engage with cutting-edge research, network with
                        experts, and stay updated on the latest industry trends
                        by attending our conferences.
                      </p>

                      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-6'>
                        <div className='bg-blue-50 p-6 rounded-lg border border-blue-100'>
                          <div className='w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-6 w-6 text-blue-600'
                              fill='none'
                              viewBox='0 0 24 24'
                              stroke='currentColor'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2'
                              />
                            </svg>
                          </div>
                          <h3 className='font-semibold text-lg text-gray-800 mb-2'>
                            Learn from Experts
                          </h3>
                          <p className='text-gray-600 text-sm'>
                            Access presentations from leading researchers and
                            industry pioneers.
                          </p>
                        </div>

                        <div className='bg-green-50 p-6 rounded-lg border border-green-100'>
                          <div className='w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-6 w-6 text-green-600'
                              fill='none'
                              viewBox='0 0 24 24'
                              stroke='currentColor'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
                              />
                            </svg>
                          </div>
                          <h3 className='font-semibold text-lg text-gray-800 mb-2'>
                            Network Globally
                          </h3>
                          <p className='text-gray-600 text-sm'>
                            Connect with professionals from around the world in
                            your field.
                          </p>
                        </div>

                        <div className='bg-purple-50 p-6 rounded-lg border border-purple-100'>
                          <div className='w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-6 w-6 text-purple-600'
                              fill='none'
                              viewBox='0 0 24 24'
                              stroke='currentColor'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
                              />
                            </svg>
                          </div>
                          <h3 className='font-semibold text-lg text-gray-800 mb-2'>
                            Stay Updated
                          </h3>
                          <p className='text-gray-600 text-sm'>
                            Discover the latest innovations and research
                            breakthroughs.
                          </p>
                        </div>
                      </div>

                      {/* <div className="flex flex-col sm:flex-row gap-4">
                      <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                        </svg>
                        Find a Conference
                      </button>
                      <button className="px-6 py-3 bg-white text-blue-600 border border-blue-300 rounded-lg hover:bg-blue-50 transition-colors flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v8a2 2 0 01-2 2h-2a2 2 0 01-2-2V6z" />
                        </svg>
                        View Conference Calendar
                      </button>
                    </div> */}
                    </div>
                  )}

                  {activeTab === 'organize' && (
                    <div className='organize-content'>
                      <h2 className='text-2xl font-bold text-gray-800 mb-4'>
                        Organize a Conference
                      </h2>
                      <p className='text-gray-600 mb-6'>
                        Collaborate with AEG to organize professional
                        conferences tailored to your field, providing a platform
                        for knowledge exchange, research presentations, and
                        fostering academic-industry partnerships.
                      </p>

                      <div className='bg-yellow-50 rounded-lg p-6 mb-6 border border-yellow-100'>
                        <h3 className='font-semibold text-lg text-gray-800 mb-3'>
                          Our Conference Organization Services
                        </h3>
                        <ul className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                          <li className='flex items-start'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-yellow-600 mt-0.5 mr-2 flex-shrink-0'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            <span className='text-gray-700'>
                              Full event planning and management
                            </span>
                          </li>
                          <li className='flex items-start'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-yellow-600 mt-0.5 mr-2 flex-shrink-0'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            <span className='text-gray-700'>
                              Abstract management system
                            </span>
                          </li>
                          <li className='flex items-start'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-yellow-600 mt-0.5 mr-2 flex-shrink-0'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            <span className='text-gray-700'>
                              Speaker coordination and management
                            </span>
                          </li>
                          <li className='flex items-start'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-yellow-600 mt-0.5 mr-2 flex-shrink-0'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            <span className='text-gray-700'>
                              Marketing and participant outreach
                            </span>
                          </li>
                          <li className='flex items-start'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-yellow-600 mt-0.5 mr-2 flex-shrink-0'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            <span className='text-gray-700'>
                              Sponsorship program development
                            </span>
                          </li>
                          <li className='flex items-start'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-yellow-600 mt-0.5 mr-2 flex-shrink-0'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            <span className='text-gray-700'>
                              Proceedings publication services
                            </span>
                          </li>
                        </ul>
                      </div>

                      {/* <button className="px-6 py-3 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      Request Conference Proposal
                    </button> */}
                    </div>
                  )}

                  {activeTab === 'join' && (
                    <div className='join-content'>
                      <h2 className='text-2xl font-bold text-gray-800 mb-4'>
                        Why Join Our Conferences?
                      </h2>
                      <p className='text-gray-600 mb-6'>
                        Joining our conferences connects you with a diverse
                        research community, facilitates access to high-quality
                        discussions, and opens up avenues for collaboration in
                        both academic and industrial sectors.
                      </p>

                      <div className='grid grid-cols-1 md:grid-cols-2 gap-6 mb-6'>
                        <div className='bg-white border border-gray-200 rounded-lg p-6 shadow-sm'>
                          <h3 className='font-semibold text-lg text-gray-800 mb-3 flex items-center'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-green-500 mr-2'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            Professional Growth
                          </h3>
                          <p className='text-gray-600'>
                            Enhance your knowledge and skills through workshops,
                            presentations, and discussions with field experts.
                          </p>
                        </div>

                        <div className='bg-white border border-gray-200 rounded-lg p-6 shadow-sm'>
                          <h3 className='font-semibold text-lg text-gray-800 mb-3 flex items-center'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-green-500 mr-2'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            Research Visibility
                          </h3>
                          <p className='text-gray-600'>
                            Present your research to an international audience
                            and gain valuable feedback from peers.
                          </p>
                        </div>

                        <div className='bg-white border border-gray-200 rounded-lg p-6 shadow-sm'>
                          <h3 className='font-semibold text-lg text-gray-800 mb-3 flex items-center'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-green-500 mr-2'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            Career Opportunities
                          </h3>
                          <p className='text-gray-600'>
                            Connect with potential employers, collaborators, and
                            institutions looking for expertise in your field.
                          </p>
                        </div>

                        <div className='bg-white border border-gray-200 rounded-lg p-6 shadow-sm'>
                          <h3 className='font-semibold text-lg text-gray-800 mb-3 flex items-center'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              className='h-5 w-5 text-green-500 mr-2'
                              viewBox='0 0 20 20'
                              fill='currentColor'
                            >
                              <path
                                fillRule='evenodd'
                                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                                clipRule='evenodd'
                              />
                            </svg>
                            Latest Innovations
                          </h3>
                          <p className='text-gray-600'>
                            Be among the first to learn about cutting-edge
                            technologies and methodologies in your discipline.
                          </p>
                        </div>
                      </div>

                      <div className='bg-green-50 rounded-lg p-6 border border-green-100'>
                        <h3 className='font-semibold text-lg text-gray-800 mb-3'>
                          Testimonials
                        </h3>
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                          <div>
                            <p className='text-gray-700 italic mb-2'>
                              &ldquo;The conference provided unparalleled
                              networking opportunities and insights into the
                              latest research in my field.&rdquo;
                            </p>
                            <p className='text-gray-600 font-medium'>
                              - Dr. Sarah Johnson, University of Cambridge
                            </p>
                          </div>
                          <div>
                            <p className='text-gray-700 italic mb-2'>
                              &ldquo;Presenting my research at this conference
                              led to a collaboration that resulted in a major
                              publication.&rdquo;
                            </p>
                            <p className='text-gray-600 font-medium'>
                              - Prof. Michael Chen, MIT
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='w-screen'>
        <NewFooter />
      </div>
    </>
  );
};

export default ConferenceList;
